import React, { useMemo } from 'react';
import { defineMessages } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';

import { VideoPlayerModal } from '@atlassian/video-player-modal';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

export type Props = {
	onClose: () => void;
};

const ContainerStyles = xcss({
	position: 'fixed',
	right: '12px',
	bottom: '12px',
	zIndex: 'modal',
});

const i18n = defineMessages({
	modalTitle: {
		id: 'rovo-video-modal.confluence-modal.title',
		defaultMessage: 'Get Started with Rovo!',
		description: 'Title for the Rovo video player modal',
	},
});

export const RovoModal = ({ onClose }: Props) => {
	const analyticWebClient = useMemo(() => getAnalyticsWebClient(), []);

	const videoUrl =
		'https://www.loom.com/embed/c14e4aa4c02b47f2ac611b1904cd8026?sid=ff2188d4-7fbc-4a92-8ed1-7c963b3f78ae';

	const handleClose = () => {
		onClose();
	};

	return (
		<Box xcss={ContainerStyles}>
			<VideoPlayerModal
				onClose={handleClose}
				analyticsProduct="confluence"
				analyticsClient={analyticWebClient}
				title={i18n.modalTitle}
				url={videoUrl}
				testId="confluence-rovo-video-modal-test-id"
			/>
		</Box>
	);
};
